<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center"
                >Projeto: {{ viewModel.projectName }}</strong
              >
              <div class="btn-group ml-auto no-print">
                <!-- <download-csv
                  title="Baixar dados planilha"
                  v-if="viewModel.itens && viewModel.itens.length > 0"
                  class="btn"
                  :data="GetCsv()"
                  :separator-excel="false"
                  :name="viewModel.projectName + '.csv'"
                > -->

                <button
                  class="btn btn-success mr-1"
                  v-if="viewModel.itens && viewModel.itens.length > 0"
                  @click="GetExcel"
                >
                  <i class="fas fa-file-excel fa-1x mr-1"></i>Baixar Excel
                </button>
                <!-- </download-csv> -->

                <button class="btn btn-secondary" title="Ordernar por Id" @click="Order">
                  <i class="fas fa-sort-numeric-down fa-1x mr-1"></i> Ordenar
                </button>
              </div>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <GoogleMaps :markers="markers" />
            <b-table
              :hover="true"
              responsive
              :items="viewModel.itens"
              :fields="fields"
              select-mode="single"
              selectable
              striped
              show-empty
              empty-text="Nenhum gaau encontrado."
              @row-selected="OnRowSelected"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(date)="data">
                <span>{{ FormatDate(data.item.date) }}</span>
              </template>

              <template v-slot:cell(result)="data">
                <span>{{ ResultName(data.item.result) }}</span>
              </template>
            </b-table>
            <div
              class="row no-print"
              v-if="viewModel.itens && viewModel.itens.length > 0"
            >
              <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                <div class="form-group">
                  <label for>Atualizar</label>
                  <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Planilha..."
                    accept=".xlsx"
                    browse-text="Procurar"
                  ></b-form-file>
                </div>
              </div>
            </div>
            <div class="btn-group no-print" role="group">
              <button
                class="btn btn-secondary"
                type="reset"
                @click="$router.go(-1)"
              >
                Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../../components/RotateSquare";
import GaauService from "../../../servico/GaauService";
import ProjectService from "../../../servico/ProjectService";
import DateTime from "../../../util/DateTime";
import GoogleMaps from "../../../components/GoogleMaps";
import CsvGaauService from "../../../servico/CsvGaauService";

export default {
  name: "TableGaau",
  components: {
    RotateSquare,
    DateTime,
    GoogleMaps
  },
  data() {
    return {
      loading: false,
      file: null,
      markers: [],
      viewModel: {
        itens: [],
        projectName: "",
        projectId: ""
      },
      fields: [
        { key: "sequence", label: "Id", sortable: true },
        { key: "date", label: "Data", sortable: true },
        { key: "commonName", label: "Nome Comum", sortable: true },
        { key: "scientificName", label: "Nome Científico", sortable: true },
        { key: "origin", label: "Origem", sortable: true },
        // { key: "family", label: "Família", sortable: true },
        { key: "status", label: "Situação", sortable: true },
        { key: "heigthClass", label: "Classe Altura", sortable: true },
        // { key: "cap", label: "CAP", sortable: true },
        { key: "heigth", label: "Altura Total (m)", sortable: true },
        { key: "dap", label: "DAP", sortable: true },
        // {
        //   key: "fisrtHeigth",
        //   label: "Altura da Primeira Bifurcação (m)",
        //   sortable: true
        // },
        // { key: "radiusOne", label: "Raio 1 (N)", sortable: true },
        // { key: "radiusTwo", label: "Raio 2 (L)", sortable: true },
        // { key: "radiusThree", label: "Raio 3 (S)", sortable: true },
        // { key: "radiusFour", label: "Raio 4 (O)", sortable: true },
        // {
        //   key: "branchesInterfering",
        //   label: "Galhos Interferindo na Rede Elétrica",
        //   sortable: true
        // },
        // {
        //   key: "branchesEchoes",
        //   label: "Galhos Secos e Podres",
        //   sortable: true
        // },
        // { key: "birdWeed", label: "Erva-de-passarinho", sortable: true },
        // { key: "balancedCup", label: "Arquitetura de Copa", sortable: true },
        // { key: "anchorCabling", label: "Cabeamento / Escora", sortable: true },
        // { key: "cavity", label: "Cavidade", sortable: true },
        // { key: "figTreeKillsWood", label: "Figueira Mata-Pau", sortable: true },
        // { key: "termite", label: "Cupim", sortable: true },
        // { key: "leafCuttingAnt", label: "Formiga-Cortadeira", sortable: true },
        // { key: "snailDrills", label: "Coleóbrocas", sortable: true },
        // { key: "fungus", label: "Fungo", sortable: true },
        // {
        //   key: "nutritionalDeficiency",
        //   label: "Deficiência Nutricional",
        //   sortable: true
        // },
        // { key: "trunkTilt", label: "Inclinação do Tronco", sortable: true },
        // {
        //   key: "epicormicShoots",
        //   label: "Brotações Epicórmica",
        //   sortable: true
        // },
        // { key: "freeArea", label: "Área Livre", sortable: true },
        // { key: "buriedLap", label: "Colo Soterrado", sortable: true },
        // {
        //   key: "sidewalkSurvey",
        //   label: "Levantamento Calçada",
        //   sortable: true
        // },

        // {
        //   key: "pedestrianCirculation",
        //   label: "Circulação dos Pedestres",
        //   sortable: true
        // },
        // {
        //   key: "circulationVehicles",
        //   label: "Circulação dos Veículos",
        //   sortable: true
        // },
        { key: "result", label: "Índice GAAU", sortable: true },
        { key: "carbon", label: "Carbono (CO2/kg)", sortable: true },
        { key: "userName", label: "Usuário", sortable: true }
      ]
    };
  },
  watch: {
    file: function (val) {
      if (!val) return;

      this.loading = true;
      ProjectService.UploadExcel(val)
        .then((response) => {
          this.loading = false;
          this.file = null;
          this.GetGrid(this.viewModel.projectId);
        })
        .catch((erro) => {
          this.loading = false;
          this.file = null;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  },
  mounted() {
    let id = this.$route.params.projectId;
    this.GetMarkers(id);
  },
  methods: {
    GetMarkers(projectId) {
      ProjectService.GetCoordinates(projectId)
        .then((result) => {
          this.markers = result.data;
          this.GetGrid(projectId);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetCsv() {
      return CsvGaauService.Get(this.viewModel.itens);
    },
    GetExcel() {
      ProjectService.ExportExcel([this.viewModel.projectId])
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.download = this.viewModel.projectName + ".xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    OnRowSelected(item) {
      let url = "/#/gaau/editar/" + item[0].id;
      window.open(url, "_self");
    },
    FormatDate(date) {
      return DateTime.FormatLocale(date);
    },
    GetGrid(projectId) {
      this.loading = true;

      GaauService.GetReportTable(projectId)
        .then((response) => {
          this.loading = false;
          this.viewModel = response.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    ResultName(result) {
      return GaauService.ResultName(result);
    },
    Order() {
      this.loading = true;
      GaauService.Reorder(this.viewModel.projectId)
        .then((response) => {
          this.loading = false;
          this.GetMarkers(this.viewModel.projectId);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
